import React from 'react'

export interface IRadioFieldProps {
  checked: boolean
  value?: any
  label?: any
  name?: string
  className?: string
  size?: 'normal' | 'large'
  onChange?: (value: any) => void
}

function RadioField({
  checked,
  value,
  label,
  name,
  className,
  size = 'normal',
  onChange,
}: IRadioFieldProps) {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.value)
    }
  }

  return (
    <label className={`dv-input-radio ${className ?? ''} ${size}`}>
      <input
        name={name}
        type="radio"
        value={value}
        checked={checked ?? false}
        onChange={handleChange}
      />
      {label ? <span>{label}</span> : ''}
    </label>
  )
}

export default RadioField
